

































import { Component, Prop, Vue } from 'vue-property-decorator';

@Component({})
export default class TravelSection extends Vue {
	@Prop({ required: true }) readonly title!: string;
	@Prop({ required: true }) readonly data!: string;
	@Prop({ required: true }) readonly odometro!: string;
	@Prop({ required: true }) readonly images!: string[];
	@Prop({ default: false }) readonly hasCarousel!: boolean;

	slide = 0;
	sliding = false;

	openImage(img: string) {
		if (img) {
			const newTab = window.open();
			if (newTab) {
				newTab.document.body.innerHTML = `<img src="${img}" style="width:100vw; height:100vh; object-fit: contain;" />`;
			}
		}
	}

	onSlideStart() {
		this.sliding = true;
	}

	onSlideEnd() {
		this.sliding = false;
	}
}
